import { useEffect, useState } from 'react';
import L from 'leaflet';

const pin = (p, cls) => L.marker(p, { interactive: false, icon: L.divIcon({ className: 'hl-pin-wrap', html: `<span class="hl-pin ${cls}">⚡</span>`, iconSize: [0, 0] }) });
const zone = (g, z, cls) => { g.addLayer(L.polyline(z, { color: '#fff', weight: 13, opacity: 0.85, interactive: false })); g.addLayer(L.polyline(z, { color: '#dc2626', weight: 9, interactive: false, className: cls })); };

// saved cable fault search zones + transient highlight (correlation path / fault preview)
export default function useFaultLayer(mapRef, faults) {
  const [hl, setHl] = useState(null);
  useEffect(() => { const on = (e) => setHl(e.detail); window.addEventListener('giss-hl', on); return () => window.removeEventListener('giss-hl', on); }, []);
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !faults?.length) return undefined;
    const g = L.layerGroup().addTo(map);
    faults.forEach((f) => { f.zones.forEach((z) => zone(g, z, `fault-zone fz-${f.id}`)); f.pins.forEach((p) => g.addLayer(pin(p, 'fault').bindTooltip(`${f.startName}: ${f.g.toFixed(1)} m ± ${f.tol.toFixed(1)} m`))); });
    return () => g.remove();
  }, [mapRef, faults]);
  useEffect(() => {
    const map = mapRef.current;
    if (!map || !hl) return undefined;
    const g = L.layerGroup().addTo(map);
    (hl.lines || []).forEach((ln) => g.addLayer(L.polyline(ln, { color: '#06b6d4', weight: 8, opacity: 0.8, interactive: false, className: 'hl-path' })));
    (hl.zones || []).forEach((z) => zone(g, z, 'hl-zone'));
    (hl.pins || []).forEach((p) => g.addLayer(L.circleMarker(p, { radius: 9, color: '#fff', weight: 3, fillColor: '#dc2626', fillOpacity: 1, interactive: false, className: 'hl-pt' })));
    return () => g.remove();
  }, [mapRef, hl]);
}
